import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  cleanAll,
  getAll,
  setDone,
} from "../../../store/reducers/todosReducer";
import { toast } from "react-toastify";
import {
  BoldFont,
  FlexRowBetween,
  ListHolder,
  MediumFont,
  RespFont,
  TextWithPic,
  TodoCard,
} from "../../common/Style";
import Accordion from "react-bootstrap/Accordion";
import Switcher from "../../common/switcher/Switcher";
import BottomMenu from "../../common/others/BottomMenu";
import plus from "../../../assets/common/plus.svg";
import tools from "../../../assets/common/menu.svg";
import logout from "../../../assets/common/logout.svg";
import FilledLoading from "../../common/loader/FilledLoading";
import GenericModal from "../../common/modals/GenericModal";
import Add from "./Add";
import Edit from "./Edit";
import ToolsOptions from "../ToolsOptions";
import ClientRoutes from "../../../navigation/Routes";
import { useHistory } from "react-router-dom";
import LogoutSpecipic from "../../common/LogOut/LogoutSpecipic";
import SetCallsRecord from "./SetCallsRecord";
import { getPaymentDetails } from "../../../store/reducers/dataReducer";
import GetPaymentDetails from "./GetPaymentDetails";

// קומפוננט תפריט בורגר
const BurgerMenu = ({
  isOpen,
  onToggle,
  children,
  position = "relative",
  top,
  left,
}) => {
  return (
    <div
      style={{
        position: position,
        zIndex: 1000,
        ...(top && { top }),
        ...(left && { left }),
      }}
    >
      {/* כפתור הבורגר */}
      <button
        onClick={(e) => {
          e.stopPropagation();
          onToggle();
        }}
        style={{
          background: "#fff",
          color: "white",
          border: "none",
          borderRadius: "0px 0px 12px 0px",
          padding: "10px 12px 12px 10px",
          cursor: "pointer",
          fontSize: 14,
          width: "44px",
          height: "44px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
          transition: "all 0.3s ease",
        }}
        title="תפריט"
      >
        <div
          style={{
            width: "23px",
            height: "2px",
            background: "#5377bb",
            position: "relative",
            transition: "all 0.3s ease",
            transform: isOpen ? "rotate(45deg)" : "none",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: "-7px",
              left: "0",
              width: "100%",
              height: "100%",
              background: "#5377bb",
              transition: "all 0.3s ease",
              opacity: isOpen ? "0" : "1",
            }}
          />
          <div
            style={{
              position: "absolute",
              top: "7px",
              left: "0",
              width: "100%",
              height: "100%",
              background: "#5377bb",
              transition: "all 0.3s ease",
              transform: isOpen ? "rotate(-90deg)" : "none",
            }}
          />
        </div>
      </button>

      {/* תפריט נפתח */}
      {isOpen && (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "absolute",
            top: "44px",
            left: "0",
            background: "white",
            borderRadius: "12px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            padding: "16px",
            minWidth: "200px",
            animation: "slideIn 0.3s ease",
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

// קומפוננט פריט תפריט
const MenuItem = ({
  icon,
  text,
  onClick,
  color = "#5377bb",
  disabled = false,
}) => {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) onClick();
      }}
      disabled={disabled}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "12px",
        width: "100%",
        padding: "12px 16px",
        background: "transparent",
        border: "none",
        borderRadius: "8px",
        cursor: disabled ? "not-allowed" : "pointer",
        color: disabled ? "#999" : color,
        fontSize: "14px",
        fontWeight: "500",
        transition: "all 0.2s ease",
        opacity: disabled ? 0.6 : 1,
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.target.style.background = "#f8f9fa";
        }
      }}
      onMouseLeave={(e) => {
        e.target.style.background = "transparent";
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>{icon}</div>
      <span>{text}</span>
    </button>
  );
};

const dict = {
  ראשונה: 1,
  שניה: 2,
  שלישית: 3,
  רביעית: 4,
  חמישית: 5,
};

const MainTodos = () => {
  const { guests } = useSelector((state) => state.guestsReducer);
  let history = useHistory();
  const dispatch = useDispatch();
  const { user, isTal } = useSelector((state) => state.authReducer);
  const { todos } = useSelector((state) => state.todosReducer);
  const [showEditTodo, setShowEditTodo] = useState(false);
  const [showAddTodo, setShowAddTodo] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [showLoading, setShowLoading] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const [showCallsRecord, setShowCallsRecord] = useState(false);
  const [showPaymentDetails, setShowPaymentDetails] = useState(false);
  const [isMainMenuBurgerOpen, setIsMainMenuBurgerOpen] = useState(false);

  const setCallsRecords = (callNumber) => {
    let posC = 0;
    let negC = 0;
    if (Object.keys(guests).length > 0)
      for (const [key, value] of Object.entries(guests))
        if (value.ans.includes(`C${dict[callNumber]}`))
          if (value.ans.includes("לא")) negC++;
          else posC++;

    if (posC > 0 || negC > 0)
      setShowCallsRecord({ posC, negC, number: dict[callNumber] });
    else toast.warning(`עוד לא התקיימה שיחה ${callNumber}`);
  };

  useEffect(() => {
    setShowLoading(true);
    dispatch(getAll()).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      setShowLoading(false);
    });
    return () => {
      dispatch(cleanAll());
    };
  }, []);

  const handleSetDone = async (id, done, callNumber) => {
    const body = { done };
    dispatch(setDone(id, body)).then((res) => {
      if (!res.payload?.error) {
        setCallsRecords(callNumber);
        toast.success("הפעולה בוצעה בהצלחה");
      } else toast.error(res.payload?.error);
    });
  };

  const handleSetPayment = async (executionDate) => {
    dispatch(getPaymentDetails()).then((res) => {
      if (!res.payload?.error)
        setShowPaymentDetails({
          ...res.payload,
          executionDate,
          mikdama: user.mikdama,
          date: user.date,
        });
      else toast.error(res.payload?.error);
    });
  };

  let todosArray = useMemo(() => {
    let arr = [];
    let sortedArray = [];
    if (Object.keys(todos).length > 0) {
      for (const [key, value] of Object.entries(todos)) sortedArray.push(value);
      sortedArray.sort(
        (a, b) => new Date(a["executionDate"]) - new Date(b["executionDate"])
      );
      for (let i = 0; i < sortedArray.length; i++)
        arr.push(
          <TodoCard
            key={i}
            onClick={() => {
              if (sortedArray[i].title === "הסדרת תשלום" && !isTal)
                handleSetPayment(sortedArray[i].executionDate);
              else {
                if (user.canChangeTodos || isTal)
                  setShowEditTodo(sortedArray[i]);
                else
                  toast.warning("אינך מורשה לערוך את היומן - יש לפנות לתמיכה");
              }
            }}
            style={{
              border: "2px solid #f2f2f2",
              borderRadius: "5px",
              background: "inherit",
            }}
          >
            <div>{sortedArray[i].title}</div>
            <div style={{ fontSize: "13px" }}>
              {sortedArray[i].executionDate
                .replace(/T.*/, "")
                .split("-")
                .reverse()
                .join("/")}
            </div>
            {(sortedArray[i].title.split(" ")[0] == "הודעה" ||
              sortedArray[i].title.split(" ")[0] == "ווצאפ" ||
              sortedArray[i].title.split(" ")[0] == "תזכורת" ||
              sortedArray[i].title.split(" ")[0] == "תודה" ||
              sortedArray[i].title.split(" ")[0] == "קדם") && (
              <div
                style={{
                  fontSize: "13px",
                  padding: "3px 5px",
                  background: "#f2f2f2",
                  borderRadius: "5px",
                }}
              >
                {sortedArray[i].tal}
              </div>
            )}

            {sortedArray[i].title.split(" ")[0] != "מעבר" &&
              sortedArray[i].title.split(" ")[0] != "הסדרת" &&
              sortedArray[i].title.split(" ")[0] != "לחיצה" && (
                <div
                  style={{ width: "min-content" }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <Switcher
                    onOfColor={"#C0C0C0"}
                    color={"#7b96c4"}
                    checked={sortedArray[i].done}
                    onChange={() => {
                      if (
                        isTal &&
                        sortedArray[i].title.split(" ")[0] === "שיחה"
                      )
                        if (sortedArray[i].done === false)
                          handleSetDone(
                            sortedArray[i]._id,
                            !sortedArray[i].done,
                            sortedArray[i].title.split(" ")[1]
                          );
                        else toast.warning("לא ניתן לשנות סטטוס משימה");
                      else toast.warning("רק מנהל מערכת יכול לסמן סטטוס בוצע");
                    }}
                  />
                </div>
              )}
          </TodoCard>
        );
    }
    return arr;
  }, [todos]);

  return (
    <div
      style={{
        width: "100%",
        height: `${window.screen.availHeight}px`,
        background: "linear-gradient(to bottom, #e2ebff,#fbfdff, #ffffff)",
      }}
    >
      <BurgerMenu
        isOpen={isMainMenuBurgerOpen}
        onToggle={() => setIsMainMenuBurgerOpen(!isMainMenuBurgerOpen)}
        position="fixed"
        top="0px"
        left="0px"
      >
        <MenuItem
          icon={
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M3 7h18M3 12h18M3 17h18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
          text="אורחים"
          onClick={() => {
            history.push(ClientRoutes.User.main);
            setIsMainMenuBurgerOpen(false);
          }}
          color="#333"
        />

        <MenuItem
          icon={
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 5v14M5 12h14"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
          text="הוספת משימה"
          onClick={() => {
            if (user.canChangeTodos || isTal) {
              setShowAddTodo(true);
              setIsMainMenuBurgerOpen(false);
            } else {
              toast.warning("אינך מורשה לערוך את היומן - יש לפנות לתמיכה");
              setIsMainMenuBurgerOpen(false);
            }
          }}
          color="#333"
        />

        {/* <MenuItem
          icon={
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M9 11H15M9 15H15M9 7H15M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
          text="דוחות"
          onClick={() => {
            setShowMenu(true);
            setIsMainMenuBurgerOpen(false);
          }}
          color="#333"
        /> */}

        <MenuItem
          icon={
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M12 2L2 7L12 12L22 7L12 2Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2 17L12 22L22 17"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2 12L12 17L22 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
          text="הדרכות"
          onClick={() => {
            history.push(ClientRoutes.User.instruction);
            setIsMainMenuBurgerOpen(false);
          }}
          color="#333"
        />
        <MenuItem
          icon={
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <polyline
                points="14,2 14,8 20,8"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <line
                x1="16"
                y1="13"
                x2="8"
                y2="13"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <line
                x1="16"
                y1="17"
                x2="8"
                y2="17"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <polyline
                points="22,6 12,13 2,6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
          text="הזמנה"
          onClick={() => {
            history.push(ClientRoutes.User.editDetails);
            setIsMainMenuBurgerOpen(false);
          }}
          color="#333"
        />

        <MenuItem
          icon={
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M7 16l4-4 4 4M12 12v9"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
          text="התנתקות"
          onClick={() => {
            setShowLogout(true);
            setIsMainMenuBurgerOpen(false);
          }}
          color="#333"
        />
      </BurgerMenu>
      <FlexRowBetween style={{ justifyContent: "center", margin: "30px auto" }}>
        <BoldFont csize={"32px"} psize={"28px"}>
          לו״ז עבודה
        </BoldFont>
      </FlexRowBetween>
      <FlexRowBetween style={{ justifyContent: "center", margin: "30px auto" }}>
        <MediumFont
          csize={"22px"}
          psize={"18px"}
          style={{ textAlign: "center" }}
        >
          * נציין כי לפעמים תהיה חריגה של יום/יומיים בביצוע השיחות (הלוז ישתנה
          בהתאם לאילוצים)
        </MediumFont>
      </FlexRowBetween>

      {!isTal && (
        <FlexRowBetween
          style={{ justifyContent: "center", margin: "30px auto" }}
        >
          <Accordion>
            <Accordion.Item
              eventKey="0"
              style={{ borderTop: "1.3px solid #dee2e6" }}
            >
              <Accordion.Header>
                <div style={{ paddingLeft: "20px" }}>הבהרות על מהלך שיחה</div>
              </Accordion.Header>
              <Accordion.Body>
                <div>
                  בנאדם לא ענה ל 2 סמס בנאדם לא ענה ל 3 ווצאפ זה כבר מחשיד למה
                  הוא לא עונה - כנראה מתחמק מהתשובה
                </div>
                <div>
                  תפסנו אותו בשיחה, הבנאדם אמר שהוא לא יודע כרגע אז הטלפנית אמרה
                  לו בצורה יפה: ״האם זה בסדר מבחינתך שאסמן כרגע שאתה לא מגיע
                  ובמידה ויהיה שינוי תעדכן באחת ההודעות שקיבלת?״
                </div>
                <div>
                  אם האורח מסכים אז היא מסמנת 0 ומציינת שהוא יעדכן במידה ויהיה
                  שינוי. אורח יכול גם שלא להסכים להצעה הזו ואז היא אומרת לו:
                  תרצה שאתקשר מחר או להפסיק לבדוק איתך ואתה תעדכן שתדע באחת
                  ההודעות? והוא בוחר והיא פועלת בהתאם.
                </div>
                <div>למה היא מציעה את מה שהיא מציעה?</div>
                <div>
                  100 אחוז מהאירועים לעולם לא מגיעים לכמות שאישרו להם לדוגמא
                  שמאשרים 400 לרוב מגיעים 350-370 איש וזוגות שלא מתחייבים למספר
                  הזה אל מול האולם מפסידים המון כסף (משלמים יותר מנות מאנשים) אז
                  כל האנשים האלה שמתנדנדים ולא יודעים - עדיף לכם שלא לספור אותם
                  כדי לא להפסיד עוד יותר כסף באירוע שלכם.
                </div>
                <div>
                  הובהר לאורח שהוא יכול לעדכן כאשר יידע, בנוסף זה הוצג כשאלה ולא
                  כאמירה ואם הוא הסכים אז מעולה
                </div>
                <div>
                  בבקשה לא לרדוף ולהתחנן לאנשים שיבואו לחתונה שלכם - הם אמורים
                  לרצות לבוא לחתונה
                </div>
                <div>מטרתנו היא טובתכם, תנו לנו לעבוד 🙏</div>
                <div></div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="1"
              style={{ borderTop: "1.3px solid #dee2e6" }}
            >
              <Accordion.Header>
                <div style={{ paddingLeft: "20px" }}>״אורח לא קיבל הודעה״</div>
              </Accordion.Header>
              <Accordion.Body>
                <div>
                  ראשית, מומלץ לא להיות לחוצים, תהליך אישורי ההגעה זה באמת תהליך
                  ולא משהו שקורה ברגע.
                </div>
                <div>
                  שנית, ודאו שהמספר שמוזן במערכת אכן המספר הנכון של האורח
                </div>
                <div>
                  שבנאדם אומר שלא קיבל הודעה, 99 אחוז שהוא קיבל פשוט אנשים לא
                  רואים הודעות sms אז אל תדאגו את הווצאפ הוא יראה, ואם באמת הוא
                  חיפש ולא קיבל הודעה אז:
                </div>
                <div>
                  לעיתים רחוקות חברות הסלולר חוסמות הודעות או לא מציגות את
                  הקישור כלינק - אינו לחיץ ממספר סיבות: טלפון לא מוכר/ טלפון
                  כשר/ הגנות או כל סיבה אחרת. מה שאני אומר כאן זה לא להילחץ.
                  ראשית כתוב בהודעה: ״במידה והקישור אינו נפתח יש להגיב הודעה זו״
                  האורח מגיב ואנו נזין ידנית את תשובתו. מעבר לכך יש את סבבי
                  הווצאפ והשיחות כך שבסופו של דבר נגיע אליו, אז אפשר להיות
                  רגועים
                </div>
                <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "18px",
                    marginTop: "20px",
                  }}
                >
                  היינו מאוד שמחים שיענו לנו כבר בהודעות הרגילות כי העלות שלנו
                  נמוכה, תאמינו לנו אין לנו סיבה להשמיט הודעות
                </div>
                <div style={{ fontWeight: "bold", fontSize: "18px" }}>
                  טובתכם היא טובתנו!!!
                </div>
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>
                <div style={{ paddingLeft: "20px" }}>שעות פעילות</div>
              </Accordion.Header>
              <Accordion.Body>
                <div>
                  שליחת הודעות וביצוע השיחות בין השעות 9-20, משתנה באופן
                  רנדומלי, יסומן בלו״ז לאחר שבוצע
                </div>
                <div style={{ marginTop: "10px" }}>
                  מענה לתמיכה בשעות 10-17, עדיפות לווצאפ
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </FlexRowBetween>
      )}
      <ListHolder>{todosArray}</ListHolder>
      <div style={{ height: "40px" }} />

      {showLoading && <FilledLoading />}

      {showAddTodo && (
        <GenericModal
          init={setShowAddTodo}
          div={<Add init={setShowAddTodo} producer={user.producer} />}
        />
      )}

      {showEditTodo && (
        <GenericModal
          init={setShowEditTodo}
          div={<Edit todo={showEditTodo} init={setShowEditTodo} />}
        />
      )}

      {showMenu && (
        <GenericModal
          init={setShowMenu}
          div={
            <ToolsOptions
              data={[
                <TextWithPic
                  key={1}
                  onClick={() => history.push(ClientRoutes.User.main)}
                >
                  מוזמנים
                </TextWithPic>,
                <TextWithPic
                  onClick={() => history.push(ClientRoutes.User.instruction)}
                  key={3}
                >
                  הדרכות
                </TextWithPic>,
                <TextWithPic
                  onClick={() => history.push(ClientRoutes.User.editDetails)}
                  key={3}
                >
                  הזמנה
                </TextWithPic>,
              ]}
            />
          }
        />
      )}

      {showLogout && (
        <GenericModal
          init={setShowLogout}
          div={<LogoutSpecipic init={setShowLogout} />}
        />
      )}

      {showPaymentDetails && (
        <GenericModal
          init={setShowPaymentDetails}
          div={
            <GetPaymentDetails
              data={showPaymentDetails}
              init={setShowPaymentDetails}
            />
          }
        />
      )}

      {showCallsRecord && (
        <GenericModal
          init={setShowCallsRecord}
          div={
            <SetCallsRecord stats={showCallsRecord} init={setShowCallsRecord} />
          }
        />
      )}
    </div>
  );
};

export default MainTodos;
